module.exports = __webpack_public_path__ + "static/img/csn.1791efb5.svg";